const s = {
  name: "Doubt",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,29c0-1.7,1.3-3,3-3h9v-2h-9c-2.8,0-5,2.2-5,5H15z"/>
		<path class="st0" d="M28,17c-1.1,0-2,0.9-2,2h-2c0-2.2,1.8-4,4-4s4,1.8,4,4h-2C30,17.9,29.1,17,28,17z"/>
		<path class="st0" d="M10,19c0-1.1,0.9-2,2-2s2,0.9,2,2h2c0-2.2-1.8-4-4-4s-4,1.8-4,4H10z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18
			c9.9,0,18,8.1,18,18c0,9.9-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Doubt
};
